import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskEmployeeVm } from '../my-osk-employee-vm.model';

/** Employees of the current OSK with the owner first; the boss and the office read it. */
@Injectable({ providedIn: 'root' })
export class MyOskEmployeesService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskEmployees`;
  }

  get(): Observable<IMyOskEmployeeVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IMyOskEmployeeVm[]>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
